import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=a68635ee&functional=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=a68635ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports